









import {Component, Prop, Vue} from "vue-property-decorator";
import {RouterStore} from '@/interfaces/store-interfaces/router-store.interface';

@Component
export default class ImageText extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  @Prop() image: string;
  @Prop() text!: string;
}
